import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelParamsDetail } from "../types";

export const useClientModelParams = (model_id: string) => {
  return useQuery({
    queryKey: ["client", "model", model_id, "params"],
    enabled: model_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/params`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelParamsDetail;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
